import React from 'react';
import { cn } from '../../../lib/utils';

export const TaskyTable = React.forwardRef<HTMLTableElement, React.TableHTMLAttributes<HTMLTableElement>>(
  ({ className, children, ...rest }, ref) => (
    <div className="bg-white rounded-tasky-md border border-warm-border overflow-x-auto overflow-y-hidden">
      <table ref={ref} {...rest} className={cn('w-full text-sm', className)}>
        {children}
      </table>
    </div>
  ),
);
TaskyTable.displayName = 'TaskyTable';

export const TaskyTableHead: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({
  className,
  children,
  ...rest
}) => (
  <thead {...rest} className={cn('bg-gray-50 border-b border-warm-border', className)}>
    {children}
  </thead>
);

export const TaskyTableBody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = ({
  className,
  children,
  ...rest
}) => (
  <tbody {...rest} className={cn('divide-y divide-warm-border', className)}>
    {children}
  </tbody>
);

export const TaskyTableRow: React.FC<
  React.HTMLAttributes<HTMLTableRowElement> & { hoverable?: boolean }
> = ({ className, hoverable = true, children, ...rest }) => (
  <tr
    {...rest}
    className={cn(hoverable && 'hover:bg-gray-50 transition-colors', className)}
  >
    {children}
  </tr>
);

export const TaskyTableHeaderCell: React.FC<
  React.ThHTMLAttributes<HTMLTableCellElement> & { align?: 'left' | 'right' | 'center' }
> = ({ className, align = 'left', children, ...rest }) => (
  <th
    scope="col"
    {...rest}
    className={cn(
      // globals.css の `* { word-break: break-all }` で列が1文字幅まで縮み、見出しが縦に割れるので折り返さない。
      // 収まらない表は TaskyTable の overflow-x-auto で横にスクロールする
      'p-3 font-medium text-gray-500 text-xs uppercase tracking-wider whitespace-nowrap',
      align === 'right' && 'text-right',
      align === 'center' && 'text-center',
      align === 'left' && 'text-left',
      className,
    )}
  >
    {children}
  </th>
);

export const TaskyTableCell: React.FC<
  React.TdHTMLAttributes<HTMLTableCellElement> & { align?: 'left' | 'right' | 'center' }
> = ({ className, align = 'left', children, ...rest }) => (
  <td
    {...rest}
    className={cn(
      'p-3 text-dark',
      align === 'right' && 'text-right',
      align === 'center' && 'text-center',
      className,
    )}
  >
    {children}
  </td>
);
